<script>
import CandidateImage from '@/components/candidate/candidate-image.vue'
import baseMixin from '@/mixins/baseMixin'
import candidateMixin from '@/mixins/candidateMixin'
import VuetifyTextClass from '@/shared/constants/core/VuetifyTextClass'
import Colours from '@/shared/constants/design/Colours'
import { mapGetters } from 'vuex'

export default {
  name: 'BookableEducatorCard',
  components: { CandidateImage },
  mixins: [baseMixin, candidateMixin],
  props: {
    educator: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      Colours,
      VuetifyTextClass,
    }
  },
  computed: {
    ...mapGetters({
      isQueueFull: 'bookingCreate/isQueueFull',
      queryContext: 'bookingCreate/bookableEducatorQueryContext',
    }),
    totalScheduleDays() {
      return this.queryContext?.schedules?.length ?? 0
    },
    educatorTypes() {
      return (this.educator.candidateTypes ?? [])
        .map(({ title }) => title)
        .join(', ')
    },
    isAddDisabled() {
      return !this.isFullyAvailable || this.isQueueFull
    },
    daysAvailable() {
      return this.educator.availability?.noOfDaysAvailable ?? 0
    },
    isFullyAvailable() {
      return this.daysAvailable >= this.totalScheduleDays
    },
    availabilityBadgeClasses() {
      return this.isFullyAvailable
        ? [Colours.semanticsSuccess100, Colours.text.semanticsSuccess500]
        : [Colours.semanticsWarning200, Colours.text.semanticsWarning500]
    },
  },
}
</script>

<template>
  <div>
    <v-card
      :class="[isFullyAvailable ? 'cursor-grab' : 'drag-disabled']"
      class="rounded-lg pa-4"
      outlined
      elevation="0"
      data-testid="bookable-educator-card"
    >
      <div class="d-flex align-center">
        <div class="d-flex flex-column flex-grow-1 min-width-0 overflow-hidden">
          <div class="d-flex min-width-0 overflow-hidden">
            <v-lazy>
              <CandidateImage
                :id="educator.id"
                :full-name="educator.fullName"
                size="72"
                :font-size="22"
                margin="mr-4"
                rounded
              />
            </v-lazy>

            <div class="flex-grow-1 min-width-0 overflow-hidden">
              <div class="d-flex align-center flex-wrap">
                <button
                  type="button"
                  class="inline-text-btn display-xs ma-0 pa-0 text-truncate text-left"
                  data-testid="educator-name"
                  @click="$emit('view-candidate', educator.id)"
                >
                  {{ educator.fullName }}
                </button>
                <span
                  class="d-inline-flex align-center text-caption-bold rounded-pill px-2 py-1 ml-2 flex-shrink-0 text-no-wrap"
                  :class="availabilityBadgeClasses"
                >
                  {{
                    isFullyAvailable
                      ? $t('bookingCreateV2.selectEducatorsStep.availableBadge')
                      : $t(
                          'bookingCreateV2.selectEducatorsStep.availablePartialBadge',
                          [daysAvailable, totalScheduleDays]
                        )
                  }}
                </span>
              </div>
              <!-- We will enable educator types in the future once BE maps it
               properly -->
              <!-- <div
                v-if="educatorTypes"
                class="text-sm mt-1 text-truncate"
                data-testid="educator-types"
              >
                {{ educatorTypes }}
              </div> -->

              <div class="text-sm mt-1">
                {{
                  $t('bookingCreateV2.selectEducatorsStep.lastBookedLabel', [
                    educator.lastBookedDate
                      ? displayDate(educator.lastBookedDate)
                      : $t(
                          'bookingCreateV2.selectEducatorsStep.lastBookedNever'
                        ),
                  ])
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="flex-shrink-0 ml-4">
          <v-btn
            outlined
            class="pa-3 text-md-bold border-grey-200"
            :disabled="isAddDisabled"
            data-testid="educator-add-btn"
            :aria-label="
              $t('bookingCreateV2.selectEducatorsStep.addBtn') +
                ' ' +
                educator.fullName
            "
            @click="$emit('add', educator)"
          >
            <v-icon small left>mdi-plus</v-icon>
            {{ $t('bookingCreateV2.selectEducatorsStep.addBtn') }}
          </v-btn>
        </div>
      </div>
    </v-card>
  </div>
</template>
